import useData from "./useData";
export default function TecnologiasGrid({ mostrar }) {

    const { tecnologias } = useData();
    return (
        <div className="image-grid">

            {tecnologias.map((item, index) => {
                return mostrar.includes(item.name) ? (
                    <img key={index} src={item.imagen} alt={item.name} />
                ) : null;
            })}

        </div>
    );
}
